import React, { useState } from "react";
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from "reactflow";
import { useDispatch } from "react-redux";
import { getsampleNodeEdgeType } from "../../../store/user/actions";

export default function CustomEdge({
  id,
  data,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style = {},
  status,
  markerEnd,
}) {
  const [isChecked, setChecked] = useState(data.status);
  const dispatch = useDispatch();

  // Bezier curve for smooth and natural flow
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  const resetCheckbox = () => {
    const newStatus = isChecked ? 2 : 1;
    dispatch(getsampleNodeEdgeType({ id: data.id, type: newStatus }));
    setChecked(!isChecked);
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            pointerEvents: "all",
          }}
          className="nodrag nopan"
        >
          <label className="switch_slide">
            <input
              type="checkbox"
              name={data.label + id}
              id={data.label + id}
              checked={isChecked}
              disabled={status === 0}
            />
            <div
              className="slider round"
              htmlFor={data.label + id}
              onClick={resetCheckbox}
            >
              <span className="on">AND</span>
              <span className="off">OR</span>
            </div>
          </label>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
